/* src/app/components/billing/reports/denial-report/denial-report.component.css */
.report-container {
  display: flex;
  margin: 16px;
  width: 100%;
}
.report-label {
  margin-bottom: 4px;
  font-weight: 600;
}
.chart-info-container {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  width: 100%;
  flex-wrap: wrap;
}
#chart {
  width: 58%;
}
.detailed-data-container {
  width: 40%;
}
@media (max-width: 768px) {
  .chart-info-container {
    flex-direction: column;
  }
  #chart,
  .detailed-data-container {
    width: 100%;
  }
}
.radio-group-container {
  display: flex;
  flex-direction: column;
}
.radio-label {
  font-weight: 500;
  margin-bottom: 5px;
}
/*# sourceMappingURL=denial-report.component-BIAXO7DT.css.map */
